import { gql } from "@apollo/client";

export const CRM_SENDERS = gql`
  query CrmSenders($where: CrmSenderWhereInput, $take: Int, $skip: Int) {
    crmSenders(where: $where, take: $take, skip: $skip) {
      data {
        id
        email
        displayName
        provider
        status
        dailyLimit
        sentToday
        warmupStatus
        warmupDay
        bounceRate
        reputation
        assignedCampaignIds
        lastSentAt
      }
      count
    }
  }
`;

const crmSenders = { CRM_SENDERS };
export default crmSenders;
